
import { Cpu } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { toast } from "@/hooks/use-toast";
import { useSettings } from "@/providers/SettingsProvider";
import { Alert, AlertDescription } from "@/components/ui/alert";

export const AIFeatureSettings = () => {
  const { aiDisabled, toggleAI } = useSettings();
  
  const handleAIToggle = (enabled: boolean) => {
    toggleAI(enabled);
    
    toast({
      title: !enabled ? "AI Features Disabled" : "AI Features Enabled",
      description: !enabled 
        ? "All AI analysis will be skipped" 
        : "AI analysis will be performed as normal",
      variant: !enabled ? "destructive" : "default",
    });
  };

  return (
    <div className="space-y-2">
      <label className="text-xs font-medium text-white/70 flex items-center">
        <Cpu className="h-3.5 w-3.5 mr-1.5" />
        AI Features
      </label>
      <div className="flex items-center justify-between">
        <span className="text-xs">
          {!aiDisabled ? "AI enabled" : "AI disabled"}
        </span>
        <Switch
          checked={!aiDisabled}
          onCheckedChange={handleAIToggle}
          className="data-[state=checked]:bg-green-500"
        />
      </div>
      
      {aiDisabled && (
        <Alert variant="destructive" className="bg-red-100 mt-2">
          <AlertDescription className="text-xs text-red-600">
            AI features are currently disabled. Some functionality may be limited.
          </AlertDescription>
        </Alert>
      )}
      
      <p className="text-xs text-white/50 italic">
        Toggle AI analysis features on or off
      </p>
    </div>
  );
};
